import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { enumLclTrackingStates } from '@enum/enumLclTrackingStates';
import { enumShipmentState } from '@data-layer/enums/lcl';
import { LCLShipmentModel } from '@data-layer/models/lcl';

@Component({
  selector: 'app-lcl-shipment-voyage-info',
  templateUrl: './lcl-shipment-voyage-info.component.html',
  styleUrls: ['./lcl-shipment-voyage-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclShipmentVoyageInfoComponent implements OnInit {
  @Input() public shipment: LCLShipmentModel;

  public lclTrackingStates: typeof enumLclTrackingStates = enumLclTrackingStates;
  public enumShipmentState: typeof enumShipmentState = enumShipmentState;

  constructor() {}

  public ngOnInit(): void {}
}
